export const formatSchemaUser = (e) => {
  const {
    _id = "",
    name = "",
    birthDay = "",
    lastNames = "",
    phoneNumber = "",
    email = "",
    password = "",
    homeNumber = "",
    houseNumber = "",
    dateCreated = "",
    conecktaId = "",
    profileUrl = "",
    uid = "",
  } = e;

  const directionObj = e.direction || {};

  const {
    streetName = "",
    colonia = "",
    state = "",
    CP = "",
    direction = "",
    coordinates = {},
  } = directionObj;
  const data = {
    _id,
    CP,
    uid,
    name,
    birthDay,
    lastNames,
    phoneNumber,
    email,
    password,
    streetName,
    colonia,
    direction,
    coordinates,
    homeNumber,
    houseNumber,
    dateCreated,
    conecktaId,
    profileUrl,
    state,
  };

  return data;
};

export const formatSchemaCar = (e) => {
  const {
    model = "",
    year = "",
    serial = "",
    plates = "",
    color = "",
    mexicoProtectID = "",
    pictures = "",
    user = "",
    _id = "",
    nickName = "",
    brand = "",
    type = "",
  } = e;

  const data = {
    _id,
    model,
    year,
    type,
    serial,
    plates,
    color,
    brand,
    mexicoProtectID,
    nickName,
    user: user._id,
    pictures,
  };

  return data;
};

export const formatSchemaContact = (e) => {
  const { name, phoneNumber, relation, user, _id } = e;

  const data = {
    name,
    phoneNumber,
    relation,
    user: user._id,
    _id,
  };

  return data;
};

export const formatSchemaReport = (e) => {
  const {
    dateReported = "",
    title,
    direction,
    description,
    coordinates,
    status,
    user,
    _id,
  } = e;

  const data = {
    dateReported,
    title,
    direction,
    description,
    coordinates,
    status,
    user: user._id,
    _id,
  };

  return data;
};
